import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-MOZMSUNE.mjs";
import "./chunk-KEIR6QF5.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
